import React, { useMemo } from 'react';
import c from 'classnames';
import { useSelector } from 'react-redux';

import { ImmutableEntity, ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { type NodeFAQ as NodeFaqType } from '../../../types/uncinc_profile/nodes';
import { AccordionItem, WysiwygField } from '../../../components';

export interface NodeFaqProps {
  entity: ImmutableEntity<NodeFaqType>;
  showLabel?: boolean;
  className?: string;
}

const NodeFaq: React.FC<NodeFaqProps> = ({ entity, className, showLabel = true }) => {
  const node = entity.toJS();
  const uuid = node.uuid[0].value;
  const title = node.title[0].value;
  const theme = node.field_themes[0]?.entity.name[0].value;
  const body = node.body[0]?.processed;

  const hash = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['router', 'location', 'hash'], ''));

  const initialCollapsed = useMemo(() => !(hash.slice(1) === uuid), [hash, uuid]);

  return (
    <AccordionItem
      id={uuid}
      className={c(className, 'NodeFaq')}
      title={title}
      label={showLabel ? theme : undefined}
      initialCollapsed={initialCollapsed}
    >
      <WysiwygField html={body} />
    </AccordionItem>
  );
};

export default NodeFaq;
